export const commonapiurl = "https://promanage-backend-qsza.onrender.com/api/"

export const montharr = [
    "Jan", "Feb", "Mar", "April", "May" , "June", "July", "Aug", "Sep", "Oct",
    "Nov", "Des"
]

// https://quiz12345.vercel.app/dashboard